import React from "react";
import { Conversation } from "@/src/types/Entities/Messaging/Conversation";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { DraftsOutlined, EmailOutlined } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { conversationHasUnreadMessage, formatMessageDate } from "@/src/services/messagingService";
import { ButtonBase, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { mergeSx } from "@/src/utils/mergeSx";
import { conversationTableRowStyle } from "./conversationTableRowStyle";

type ConversationTableRowProps = {
  conversation: Conversation;
  caseId: number;
};

export default function ConversationTableRow({ conversation, caseId }: ConversationTableRowProps) {
  const navigate = useNavigate();
  const conversationPath = conversation.id ? `/servicewelt/nachrichten/fall/${caseId}/konversation/${conversation.id}` : null;
  const hasUnreadMessage = conversationHasUnreadMessage(conversation);

  const messageDate = formatMessageDate(conversation.latestMessageCreatedDate);

  return (
    <TableRow hover sx={conversationTableRowStyle.row} onClick={() => conversationPath && navigate(conversationPath)}>
      <TableCell sx={mergeSx(conversationTableRowStyle.hiddenColumn, conversationTableRowStyle.column)}>
        <Stack sx={conversationTableRowStyle.iconStack}>
          {hasUnreadMessage ? (
            <Stack sx={mergeSx(conversationTableRowStyle.unreadIconContainer, conversationTableRowStyle.icon)}>
              <EmailOutlined />
            </Stack>
          ) : (
            <DraftsOutlined sx={conversationTableRowStyle.icon} />
          )}
        </Stack>
      </TableCell>
      <TableCell sx={mergeSx(conversationTableRowStyle.subjectColumn, conversationTableRowStyle.column, conversationTableRowStyle.columnCenter)}>
        <ButtonBase
          aria-label={`Nachricht ${conversation.subject} vom ${messageDate} öffnen`}
          disabled={!conversationPath}
          onClick={(event) => {
            event.stopPropagation();
            if (conversationPath) {
              navigate(conversationPath);
            }
          }}
          sx={conversationTableRowStyle.messageButton}
        >
          <Typography noWrap sx={conversationTableRowStyle.textOverflow}>
            {hasUnreadMessage ? <strong>{conversation.subject}</strong> : conversation.subject}
          </Typography>
        </ButtonBase>
      </TableCell>
      <TableCell align={"right"} sx={mergeSx(conversationTableRowStyle.column, conversationTableRowStyle.dateColumn)}>
        <Typography>{messageDate}</Typography>
      </TableCell>
    </TableRow>
  );
}
